import { getFormattedDate } from 'utils';

export const renderDate = ({ value }: { value?: Date }) => {
    if (!value) return;

    return getFormattedDate(value.toISOString());
};
